import $ from "jquery";
import React from 'react';
import { Icon } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

import Edit from './edit';
import Title from '../../title';
import Loading from '../../loading';
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';

class Executive extends React.Component {

  state = {
    employeeDetails: [], menuPermission: [], roles: [], status: 'Active'
  }

  componentDidMount() {
    this.menuControl();
    this.executiveRoles();
  }

  executiveRoles() {
    let context = this;
    context.setState({ load: true, message: 'Getting Roles', })
    $.ajax({
      type: 'POST', url: Server() + 'EmployeeDetails/roles.php',
      success: function (data) {
        try {
          data = JSON.parse(data);
          context.setState({ roles: data, load: false })
        } catch (e) {
          alert('Error!!!');
          context.setState({ load: false, });
        }
      },
      error: function (e) {
        alert('Try again1!!')
        context.setState({ load: false });
      }
    });
  }

  menuControl() {
    let menuPermission = Permission('executive', this.props.menus);
    if (menuPermission.view) {
      this.getEmployeeDetails();
    }
    this.setState({ menuPermission })
  }

  getEmployeeDetails() {                                                 
    let context = this;
    context.setState({ load: true, message: 'Getting Employee Details', })
    $.ajax({
      type: 'POST', url: Server() + 'EmployeeDetails/get.php',
      success: function (data) {
        try {
          data = JSON.parse(data);
          context.setState({ employeeDetails: data, searchclose: true, load: false })
        } catch (e) {
          context.setState({ load: false, });
          alert('Error!!!');
        }
      },
      error: function (e) {
        alert('Try again1!!')
        context.setState({ load: false });
      }
    });
  }

  

  changeRole(role) {
    let context = this;
    let { employeeDetails } = this.state;
    context.setState({ load: true, message: 'Reset Password', })
    $.ajax({
      type: 'POST', data: { id: context.state.eid, role },
      url: Server() + 'EmployeeDetails/changerole.php',
      success: function (data) {
        if (data == 1) {
          alert('Role Changed Success!!!');
          employeeDetails.map((c) => {
            if (c.id == context.state.eid) {
              c.role = role;
            }
          })
          context.setState({ load: false, employeeDetails, dialog: false });
        }
        else {
          context.setState({ load: false, });
          alert('Failed')
        }
      },
      error: function (e) {
        alert('Try again1!!')
        context.setState({ load: false });
      }
    });
  }

  changeStatus2() {
    let status = this.state.status;
    if (status == 'Active') {
      this.setState({ status: 'Inactive' })
    }
    else {
      this.setState({ status: 'Active' })
    }
  }

  render() {
    let { load, message, employeeDetails, status } = this.state;
    let cook = (ReadCookie("vaigai"));
    let eid = cook.id;
    let si = 1;
    return (
      <div>
        <Title title={'Executive'} openDrawer={this.props.openDrawer} menus={this.props.menus} />
        <Loading load={load} message={message} />
        {
          this.state.menuPermission.view ?
          <div style={{ margin: '10px' }}>
          <div style={{display: 'flex'}}>
            <div>
              <br/>
              { this.state.menuPermission.add ?
                <Edit type='add' getEmployeeDetails={this.getEmployeeDetails.bind(this)} />:''
              }
            </div>
            <FormControl style={{marginLeft: '3%', width: '20%'}}>
              Status<br/>
              <Select labelId="demo-simple-select-label"
                id="demo-simple-select" value={status} onChange={this.changeStatus2.bind(this)}>
                <MenuItem value={'Active'}>Active</MenuItem>
                <MenuItem value={'Inactive'}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>
          <table id='table' width='100%'>
            <tr>
              <th id='th'><center>Sino</center></th>
              <th id='th'><center>Name</center></th>
              <th id='th'><center>Mobile</center></th>
              <th id='th'><center>Alt. Mobile</center></th>
              <th id='th'><center>Email</center></th>
              <th id='th'><center>Status</center></th>
              <th id='th'><center>Device Id</center></th>
              {eid == 1 || eid == 13 || eid == 6 ?
                (<th id='th'><center>Role</center></th>) :
                ''
              }
              { this.state.menuPermission.edit ?
                <th id='th'><center>Action</center></th>:''
              }
            </tr>
            {
              employeeDetails.map((c) => {
                if (status == c.status) {
                  return (
                    <tr>
                      <td><center>{si++}</center></td>
                      <td>{c.name}</td>
                      <td>{c.mobile}</td>
                      <td>{c.alt_mobile}</td>
                      <td>{c.mailid}</td>
                      <td><center>{c.status}</center></td>
                      <td><center>{c.device_id}</center></td>
                      { eid == 1 || eid == 13 || eid == 6 ?
                        (<td onClick={ () => { this.setState({ eid: c.id, dialog: true }) }}><div style={{color: '#5BB3D6', cursor: 'pointer'}}>{c.role}</div></td>) :
                        ''
                      }
                      { this.state.menuPermission.edit ?
                        <td>
                          <center>
                            <Edit type="edit" data={c} employeeDetails={employeeDetails}
                              updateData={(employeeDetails) => { this.getEmployeeDetails() }} />
                          </center>
                        </td>:''
                      }
                    </tr>
                  )
                }
              })
            }
          </table>
        </div>:
        <center>You Are Not Allow To Access This Menu!!!</center>
        }

        <Dialog onClose={ () => { this.setState({ dialog: false }) }} open={this.state.dialog}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 400}}> {"Edit Role"} </DialogTitle>
          <DialogContent>
            <List>
              { 
                this.state.roles.map((c) => {
                  return (
                    <ListItem onClick={this.changeRole.bind(this, c.role)} 
                      style={{margin: '3%', cursor: 'pointer', color: '#5BB3D6'}}>
                      <h3>{c.role}</h3>
                    </ListItem>
                  )
                })
              }
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Executive;
